var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSadFace(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 81.43,
    height: 81.43,
    viewBox: "0 0 81.43 81.43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6079",
    "data-name": "Group 6079",
    transform: "translate(-174.285 -173.97)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_9502",
    "data-name": "Ellipse 9502",
    transform: "translate(174.285 173.97)",
    fill: "#c31010",
    stroke: "#c31010",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 40.715,
    cy: 40.715,
    r: 40.715,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40.715,
    cy: 40.715,
    r: 38.715,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_100542",
    "data-name": "Path 100542",
    d: "M7505.314,5626.282l13.991,7.942-13.991,5.834",
    transform: "translate(-7313.092 -5425.203)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_100543",
    "data-name": "Path 100543",
    d: "M7519.306,5626.282l-13.991,7.942,13.991,5.834",
    transform: "translate(-7282.228 -5425.203)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_100544",
    "data-name": "Path 100544",
    d: "M7515.967,5680.53s2.885-8.324,10.9-8.186a10.9,10.9,0,0,1,5.09,1.338,13.951,13.951,0,0,1,5.836,6.847",
    transform: "translate(-7311.881 -5446.27)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSadFace);
export default __webpack_public_path__ + "static/media/SadFace.b54ac9a050f15e95098e551f31f353ed.svg";
export { ForwardRef as ReactComponent };